import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
export const OverviewIcon: FC<{
  active: boolean;
}> = t0 => {
  const $ = _c(7);
  const {
    active
  } = t0;
  const t1 = active ? "#084C83" : "transparent";
  let t2;
  if ($[0] !== t1) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M16.2779 12.8887C16.9527 12.8887 17.519 13.4455 17.4158 14.1118C16.8106 18.0318 13.4548 20.9423 9.40742 20.9423C4.92952 20.9423 1.30005 17.3129 1.30005 12.836C1.30005 9.1476 4.10215 5.71181 7.25689 4.93497C7.93479 4.7676 8.62952 5.24445 8.62952 5.94234C8.62952 10.6708 8.78847 11.8939 9.68636 12.5592C10.5843 13.2244 11.64 12.8887 16.2779 12.8887Z" stroke="currentColor" fill={t1} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = active ? "#084C83" : "transparent";
  let t4;
  if ($[2] !== t3) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M20.6926 8.95121C20.7463 5.91331 17.0147 1.01647 12.4674 1.10068C12.1137 1.107 11.8305 1.40173 11.8147 1.75437C11.7 4.25226 11.8547 7.4891 11.9411 8.95647C11.9674 9.41331 12.3263 9.77226 12.7821 9.79858C14.2905 9.88489 17.6453 10.0028 20.1074 9.63015C20.4421 9.57963 20.6874 9.2891 20.6926 8.95121Z" stroke="currentColor" fill={t3} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t4}</svg>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};